var Color = require('color');

export function darken(color: string, by: number) {

    //var c: Color;
    var c;
    c = Color(color);

    return c.darken(by / 100).hex();
}

export function lighten(color: string, by: number) {

    var c;
    c = Color(color);

    return c.lighten(by / 100).desaturate(10 / 100).hex();
}

export function turnColors(color,by){
    var c = Color(color).object();
    if(c.isDark)
        return Color({r : c.r+by.r , g:c.g+by.g,b : c.b+by.b}).hex()
    else
        return Color({r : c.r-by.r , g:c.g-by.g,b : c.b-by.b}).hex()
}

export function textColor(color: string): string {
    var c;
    c = Color(color);

    var l = c.getLuminance();

    if (l>0.5)
        return "#111";
    else
        return "#EEE";
}
